var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('cropAlerts.title')))]),_c('v-card-text',[_c('v-row',[_c('v-col',[_c('h3',[_vm._v(_vm._s(_vm.$t('cropAlerts.waterAlerts')))])]),_c('v-col',{staticClass:"flex-container"},_vm._l((_vm.waterAlerts()),function(zone,index){return _c('div',{key:index},[_vm._v(_vm._s(zone.zoneName))])}),0)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }